import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './styles/main.scss';

import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client';
import SignalRService from './signalRController';

const client = new ApolloClient({
    uri: '/graphql',
    cache: new InMemoryCache({ resultCaching: false })
});

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

ReactDOM.render(
    <ApolloProvider client={client}>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                    <App />
            </ConnectedRouter>
        </Provider>
    </ApolloProvider>,
    document.getElementById('root'));

registerServiceWorker();

SignalRService.registerReceiveEvent("ReceiveMessage",
    (msg) => {
        console.log(msg);
    }
);
